import { cache } from 'react'
import { fetchPropertyDetails, fetchPropertyReviews } from './PropertyDetails'

// React cache() deduplicates these calls within a single server request,
// preventing duplicate API calls between page.tsx and screen components.
export const getPropertyDetails = cache(
  (slug: string, checkin?: string, checkout?: string) =>
    fetchPropertyDetails(slug, checkin, checkout),
)

export const getPropertyReviews = cache(
  (uid: string, page: number) => fetchPropertyReviews(uid, page),
)
